import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeSchoolFiles = data => {
  const schoolFile = new schema.Entity('schoolFiles')
  return normalize(data, [schoolFile])
}

const defaultFilters = {
  title: '',
  benchmarked: 'false',
  /*judgement: 'all',
  moderationType: '',*/
  owner_name: ''
  //currentLimit: DEFAULT_LIMIT,
}

const SchoolFilesReducer = combineReducers({
  fetchSchoolFilesRequest: createRequestReducer('SCHOOL_FILES:FETCH'),

  filter: createReducer(defaultFilters, {
    /*'SCHOOL_FILES:LOAD_MORE': state => ({
      ...state,
      currentLimit: state.currentLimit + LOAD_MORE_STEP
    }),*/
    'SCHOOL_FILES:SET_SEARCH_FILTERS': (state, { filters }) => ({
      ...state,
      //currentLimit: DEFAULT_LIMIT,
      ...filters
    }),
    'SCHOOL_FILES:RESET_FILTERS': state => ({ ...defaultFilters })
  }),
  schoolFiles: createReducer(null, {
    'SCHOOL_FILES:FETCH_REQUEST_SUCCESS': (state, { response }) => {
      return normalizeSchoolFiles(response.data.assessment_files)
    }
  })
})

export default SchoolFilesReducer
